import * as React from 'react';
import { PropertyWithOccupants } from '@centecomm/portal-service';

import { CheckMark } from '../../../Icons';

import styles from './property-selection.module.css';

interface PropertySelectionProps {
    activePropertyIds: number[];
    togglePropertySelection: (propertyId: number) => void;
    property: PropertyWithOccupants;
    isActive?: boolean;
    showSelectedOnly?: boolean;
}

function PropertySelection({
    activePropertyIds,
    togglePropertySelection,
    property,
    isActive,
    showSelectedOnly = false,
}: PropertySelectionProps): React.ReactElement<PropertySelectionProps> {
    const id = typeof property.id === 'string' ? parseInt(property.id, 10) : property.id;
    const active = isActive || activePropertyIds.includes(id);
    const showSelected = showSelectedOnly && !activePropertyIds.includes(id);

    return (
        showSelected ? <></> : (
        <li
            onClick={() => togglePropertySelection(property.id)}
            className={`${styles.PropertySelection} ${
                active ? styles.ActivePropertySelection : styles.InActivePropertySelection
            }`}
            data-qa={`property-selection-list-item-${property.id}`}
        >
            <div className={styles.PropertySelectionIndicatorIcon}>{active && <CheckMark />}</div>
            <p>{property.name}</p>
        </li>
    ));
}

export default PropertySelection;
